var _rect, _g, _path, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlowSpecialOffer = function SvgFlowSpecialOffer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 76,
    fill: "none",
    viewBox: "0 0 120 76"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2351_11458",
    width: 120,
    height: 76,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 74,
    x: 1,
    y: 1,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2,
    rx: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2351_11458)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2351_11458)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2351_11458)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2351_11458",
    width: 121,
    height: 77,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M119.5 0.5H-0.5V76.5H119.5V0.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2351_11458)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M119.5 0.5H-0.5V76.5H119.5V0.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M28.4999 -0.5H27.1699V76.5H28.4999V-0.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M32.4999 -2.16797H31.1699V74.832H32.4999V-2.16797Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M94.5001 31.1719C94.5001 35.7719 90.7701 39.5019 86.1701 39.5019H5.83008V38.1719H86.1601C90.0301 38.1719 93.1601 35.0419 93.1601 31.1719V19.1719H94.4901V31.1719H94.5001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20F999",
    d: "M-11.99 17.75H88.01V28.42C88.01 33.02 84.28 36.75 79.68 36.75H-11.99V17.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M103.5 23.17C103.5 27.77 99.77 31.5 95.17 31.5H3.5V30.17H95.17C99.04 30.17 102.17 27.04 102.17 23.17V12.5H103.5V23.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6937",
    d: "M-11.9199 66.5019H66.6701V58.1719C66.6701 51.5419 61.7601 46.1719 55.7001 46.1719H-11.9199V66.5019Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6937",
    d: "M79.1699 54.1719C79.1699 47.5419 73.7999 42.1719 67.1699 42.1719H-6.83008V43.5019H67.1699C73.0599 43.5019 77.8399 48.2819 77.8399 54.1719V62.5019H79.1699V54.1719Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M15.5 24.5H-0.5V54.5H15.5V24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M55.0801 58.3602C55.0801 53.1402 51.3501 48.9102 46.7501 48.9102H3.08008V50.4202H46.7501C50.6201 50.4202 53.7501 53.9702 53.7501 58.3502V76.4902H55.0801V58.3502V58.3602Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF70",
    d: "M-0.5 76.5019H51.5V60.5019C51.5 55.9019 47.77 52.1719 43.17 52.1719H-0.5V76.5019Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF70",
    d: "M51.5 60.5019C51.5 55.9019 47.77 52.1719 43.17 52.1719H-0.5V53.5019H43.17C47.04 53.5019 50.17 56.6319 50.17 60.5019V76.5019H51.5V60.5019Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#276EF1",
    d: "M-0.5 9.5H96.92V18.88C96.92 22.93 93.29 26.21 88.8 26.21H-0.5V9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "black",
    strokeWidth: 9,
    d: "M102.5 -5.32812C108.85 -5.32812 114 -0.178125 114 6.17188C114 12.5219 108.85 17.6719 102.5 17.6719C96.15 17.6719 91 12.5219 91 6.17188C91 -0.178125 96.15 -5.32812 102.5 -5.32812Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M78.5201 59.8008C81.6501 59.8008 84.1901 62.3408 84.1901 65.4708C84.1901 68.6008 81.6501 71.1408 78.5201 71.1408C75.3901 71.1408 72.8501 68.6008 72.8501 65.4708C72.8501 62.3408 75.3901 59.8008 78.5201 59.8008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M78.39 72.2111C74.71 72.2111 71.72 69.2211 71.72 65.5411C71.72 61.8611 74.71 58.8711 78.39 58.8711C82.07 58.8711 85.06 61.8611 85.06 65.5411C85.06 69.2211 82.07 72.2111 78.39 72.2111ZM78.39 60.8811C75.82 60.8811 73.72 62.9711 73.72 65.5511C73.72 68.1311 75.81 70.2211 78.39 70.2211C80.97 70.2211 83.06 68.1311 83.06 65.5511C83.06 62.9711 80.97 60.8811 78.39 60.8811Z"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 74,
    x: 1,
    y: 1,
    stroke: "black",
    strokeWidth: 2,
    rx: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2351_11458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    fill: "white",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2351_11458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 76,
    fill: "white",
    transform: "translate(-0.5 0.5)"
  })))));
};
export default SvgFlowSpecialOffer;